exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".author[data-v-688d7a32]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.changes[data-v-688d7a32]{margin-top:20px}@media screen and (max-width:750px){.author[data-v-688d7a32]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:start;justify-content:flex-start}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-688d7a32","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/os/ChangeLogModal.vue
// module id = 989
// module chunks = 0